import { Color as CommonColor, Size as CommonSize, TagNameClickable, Target } from '@uikit/types';
import type { SvgIconTypes } from '@uikit/svg-icon';

type IconData = SvgIconTypes.IconData;

export enum Size {
    Small = CommonSize.Small,
    Medium = CommonSize.Medium,
    Big = CommonSize.Big,
}

export enum Color {
    Primary = CommonColor.primary,
    Secondary = CommonColor.secondary,
    Ghost = 'ghost',
}

export enum BorderRadius {
    Small = 'small',
    Big = 'big',
}

export type ClickHandlerFn = () => void;

// TODO: replace with enum TagNameClickable when it will be fixed (make parameter names with a capital letter)
export enum TagName {
    A = TagNameClickable.a,
    Button = TagNameClickable.button,
    Div = TagNameClickable.div,
}

export { Target, type IconData };
